module.exports = __webpack_public_path__ + "img/great_wall.ccb5d6ea.jpg";